const LOCAL_CONFIG = {
    NAME: 'Local',
    GRAPH_URL: "http://localhost:8000/subgraphs/id/QmYgp1oDxCqoav98dZj5NECZFSkKb66PeoXQeVTaYq21vN",
    RPC_URL: "http://localhost:8545",
    ALCHEMY_URL: "",
    CORE_ADDRESS: "0x59b670e9fA9D0A427751Af201D676719a970857b",
    STAKING_ADDRESS: "0xA51c1fc2f0D1a1b8494Ed1FE312d7C3a78Ed91C0",
    PIL_ADDRESS: "0xe7f1725E7734CE288F8367e1Bb143E90bb3F0512",
    XPIL_ADDRESS: "0x9fE46736679d2D9a65F0992F2272dE9f3c7fa6e0",
    WETH_ADDRESS: "0xCf7Ed3AccA5a467e9e704C703E8D87F634fB0Fc9",
    USDC_ADDRESS: "0x99bbA657f2BbC93c02D617f8bA121cB8Fc104Acf",
    META_NFT_ADDRESS: "0x5FbDB2315678afecb367f032d93F642f64180aa3",
};
// rinkeby staging
// const RINKEBY_CONFIG = {
//   NAME: 'Rinkeby',
//   GRAPH_URL: "https://api.thegraph.com/subgraphs/name/imtei/graph",
//   RPC_URL: "https://rinkeby.infura.io/v3/669cfa88796a4275ab75b2b71114c737",
//   ALCHEMY_URL: "https://eth-rinkeby.alchemyapi.io/v2/2j4pUs39mfCWwkt8N2LzcbgSjXQMYuAI",
//
//   CORE_ADDRESS: "0x5fD09339E35d25FeB091EBa44E6E90bcC2d4de59",
//   STAKING_ADDRESS: "0xb88101d703B73185a9aB949395a62488Fc0e3509",
//
//   PIL_ADDRESS: "0xC860782647c7fD6064A6826bD24A10A16650DFd3",
//   XPIL_ADDRESS: "0x2dA2747BCC70df97Ec801C197a9e70Cd0780CB93",
//   WETH_ADDRESS: "0xc778417E063141139Fce010982780140Aa0cD5Ab",
//   USDC_ADDRESS: "0xeb8f08a975Ab53E34D8a0330E0D34de942C95926",
//   META_NFT_ADDRESS: "0x13D6B97eef906b2e02500E40ec1c2c7240902eb3",
// }
const RINKEBY_CONFIG = {
    NAME: 'Rinkeby',
    GRAPH_URL: "https://api.thegraph.com/subgraphs/name/pilgrim-protocol/pilgrim-rinkeby\n",
    RPC_URL: "https://rinkeby.infura.io/v3/f59cc7e252fd43f39053eac979c20bac",
    ALCHEMY_URL: "https://eth-rinkeby.alchemyapi.io/v2/2j4pUs39mfCWwkt8N2LzcbgSjXQMYuAI",
    CORE_ADDRESS: "0xAD6F27c6A8C21d0a6b295374b357b6998097B787",
    STAKING_ADDRESS: "0xC5A5460bF98F8C7E3785f0811297Ad23Fb336a9F",
    PIL_ADDRESS: "0x5bd46d83Ab0DB4427F89f01F9dD0A0b9Ab266148",
    XPIL_ADDRESS: "0x0e3A2d458E8fc9370efbA4394767A2Dc5c4dD56B",
    WETH_ADDRESS: "0xc778417e063141139fce010982780140aa0cd5ab",
    USDC_ADDRESS: "0xeb8f08a975ab53e34d8a0330e0d34de942c95926",
    META_NFT_ADDRESS: "0xe2aEdC32e142e3BE8C8C009A288976523D2ABf5C",
};
const ETHEREUM_CONFIG = {
    NAME: 'Ethereum',
    GRAPH_URL: "https://api.thegraph.com/subgraphs/name/pilgrim-protocol/pilgrim-mainnet\n",
    RPC_URL: "https://mainnet.infura.io/v3/f59cc7e252fd43f39053eac979c20bac",
    ALCHEMY_URL: "https://eth-mainnet.alchemyapi.io/v2/tAVCrsEey4YzeDrN-tkgR2LVhqgvbTva",
    CORE_ADDRESS: "0xAD6F27c6A8C21d0a6b295374b357b6998097B787",
    STAKING_ADDRESS: "0xC5A5460bF98F8C7E3785f0811297Ad23Fb336a9F",
    PIL_ADDRESS: "0x5bd46d83Ab0DB4427F89f01F9dD0A0b9Ab266148",
    XPIL_ADDRESS: "0x0e3A2d458E8fc9370efbA4394767A2Dc5c4dD56B",
    WETH_ADDRESS: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    USDC_ADDRESS: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
    META_NFT_ADDRESS: "0xe2aEdC32e142e3BE8C8C009A288976523D2ABf5C",
};
// const ROPSTEN_CONFIG = {
//   NAME: 'Ropsten',
//   GRAPH_URL: "https://api.thegraph.com/subgraphs/name/imtei/graph",
//   RPC_URL: "https://rinkeby.infura.io/v3/669cfa88796a4275ab75b2b71114c737",
//   ALCHEMY_URL: "https://eth-rinkeby.alchemyapi.io/v2/2j4pUs39mfCWwkt8N2LzcbgSjXQMYuAI",
//
//   CORE_ADDRESS: "0x5fD09339E35d25FeB091EBa44E6E90bcC2d4de59",
//   STAKING_ADDRESS: "0xb88101d703B73185a9aB949395a62488Fc0e3509",
//
//   PIL_ADDRESS: "0xC860782647c7fD6064A6826bD24A10A16650DFd3",
//   XPIL_ADDRESS: "0x2dA2747BCC70df97Ec801C197a9e70Cd0780CB93",
//   WETH_ADDRESS: "0xc778417E063141139Fce010982780140Aa0cD5Ab",
//   USDC_ADDRESS: "0xeb8f08a975Ab53E34D8a0330E0D34de942C95926",
//   META_NFT_ADDRESS: "0x13D6B97eef906b2e02500E40ec1c2c7240902eb3",
// }
// const POLYGON_CONFIG = {
//   NAME: 'Polygon',
//   GRAPH_URL: "https://api.thegraph.com/subgraphs/name/imtei/graph",
//   RPC_URL: "https://rinkeby.infura.io/v3/669cfa88796a4275ab75b2b71114c737",
//   ALCHEMY_URL: "https://eth-rinkeby.alchemyapi.io/v2/2j4pUs39mfCWwkt8N2LzcbgSjXQMYuAI",
//
//   CORE_ADDRESS: "0x5fD09339E35d25FeB091EBa44E6E90bcC2d4de59",
//   STAKING_ADDRESS: "0xb88101d703B73185a9aB949395a62488Fc0e3509",
//
//   PIL_ADDRESS: "0xC860782647c7fD6064A6826bD24A10A16650DFd3",
//   XPIL_ADDRESS: "0x2dA2747BCC70df97Ec801C197a9e70Cd0780CB93",
//   WETH_ADDRESS: "0xc778417E063141139Fce010982780140Aa0cD5Ab",
//   USDC_ADDRESS: "0xeb8f08a975Ab53E34D8a0330E0D34de942C95926",
//   META_NFT_ADDRESS: "0x13D6B97eef906b2e02500E40ec1c2c7240902eb3",
// }
//
// const OPTIMISM_CONFIG = {
//   NAME: 'Optimism',
//   GRAPH_URL: "https://api.thegraph.com/subgraphs/name/imtei/graph",
//   RPC_URL: "https://rinkeby.infura.io/v3/669cfa88796a4275ab75b2b71114c737",
//   ALCHEMY_URL: "https://eth-rinkeby.alchemyapi.io/v2/2j4pUs39mfCWwkt8N2LzcbgSjXQMYuAI",
//
//   CORE_ADDRESS: "0x5fD09339E35d25FeB091EBa44E6E90bcC2d4de59",
//   STAKING_ADDRESS: "0xb88101d703B73185a9aB949395a62488Fc0e3509",
//
//   PIL_ADDRESS: "0xC860782647c7fD6064A6826bD24A10A16650DFd3",
//   XPIL_ADDRESS: "0x2dA2747BCC70df97Ec801C197a9e70Cd0780CB93",
//   WETH_ADDRESS: "0xc778417E063141139Fce010982780140Aa0cD5Ab",
//   USDC_ADDRESS: "0xeb8f08a975Ab53E34D8a0330E0D34de942C95926",
//   META_NFT_ADDRESS: "0x13D6B97eef906b2e02500E40ec1c2c7240902eb3",
// }
//
// const ARBITRUM_CONFIG = {
//   NAME: 'Arbitrum',
//   GRAPH_URL: "https://api.thegraph.com/subgraphs/name/imtei/graph",
//   RPC_URL: "https://rinkeby.infura.io/v3/669cfa88796a4275ab75b2b71114c737",
//   ALCHEMY_URL: "https://eth-rinkeby.alchemyapi.io/v2/2j4pUs39mfCWwkt8N2LzcbgSjXQMYuAI",
//
//   CORE_ADDRESS: "0x5fD09339E35d25FeB091EBa44E6E90bcC2d4de59",
//   STAKING_ADDRESS: "0xb88101d703B73185a9aB949395a62488Fc0e3509",
//
//   PIL_ADDRESS: "0xC860782647c7fD6064A6826bD24A10A16650DFd3",
//   XPIL_ADDRESS: "0x2dA2747BCC70df97Ec801C197a9e70Cd0780CB93",
//   WETH_ADDRESS: "0xc778417E063141139Fce010982780140Aa0cD5Ab",
//   USDC_ADDRESS: "0xeb8f08a975Ab53E34D8a0330E0D34de942C95926",
//   META_NFT_ADDRESS: "0x13D6B97eef906b2e02500E40ec1c2c7240902eb3",
// }
//
// export const CONFIG = {
//   1: ETHEREUM_CONFIG,
//   '0x1': ETHEREUM_CONFIG,
//   3: ROPSTEN_CONFIG,
//   '0x3': ROPSTEN_CONFIG,
//   4: RINKEBY_CONFIG,
//   '0x4': RINKEBY_CONFIG,
//   137: POLYGON_CONFIG,
//   '0x89': POLYGON_CONFIG,
//   10: OPTIMISM_CONFIG,
//   '0xa': OPTIMISM_CONFIG,
//   42161: ARBITRUM_CONFIG,
//   '0xa4b1': ARBITRUM_CONFIG,
//   31337: LOCAL_CONFIG,
//   '0x7a69': LOCAL_CONFIG,
// }
export const CONFIG = {
    1: ETHEREUM_CONFIG,
    '0x1': ETHEREUM_CONFIG,
    4: RINKEBY_CONFIG,
    '0x4': RINKEBY_CONFIG,
    31337: LOCAL_CONFIG,
    '0x7a69': LOCAL_CONFIG,
};
